module.exports = __webpack_public_path__ + "res/24-img_top_center_rtl.efe939d1118d3693082f12bed07315dc.png";